export const RECEIVE_GROUPS = 'RECEIVE_GROUPS'
export const RECEIVE_GROUP = 'RECEIVE_GROUP'
export const RECEIVE_GROUPS_ERROR = 'RECEIVE_GROUPS_ERROR'
export const CLEAR_GROUPS = 'CLEAR_GROUPS'
export const RECEIVE_RELATED_GROUP_CONTENT = 'RECEIVE_RELATED_GROUP_CONTENT'
export const DELETE_RELATED_GROUP_CONTENT = 'DELETE_RELATED_GROUP_CONTENT'
